import { Button } from '@zillow/constellation-10';
import { IconMailOutline } from '@zillow/constellation-icons';
import { useContext } from 'react';
import Link from 'next/link';
import { MultiFamilyLeadsPageContext } from '../../contexts/MultiFamilyLeadsContextProvider';
import { useContactsPageConversationsQueryParams } from '../../hooks/useContactsPageConversationsQueryParams';
import { DEFAULT_ROWS_PER_PAGE } from '../LeadsTable/components/TableFooter';
import { useSatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage } from '@zg-rentals/ts-satellite-client-react-query';

export default function ViewInMessagesButton(): JSX.Element | null {
  const { listingAlias } = useContext(MultiFamilyLeadsPageContext);
  const contactsPageQueryParams = useContactsPageConversationsQueryParams(DEFAULT_ROWS_PER_PAGE, 0);

  const { data, isLoading } = useSatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage(
    // contactsPageQueryParams is always defined when ViewInMessagesButton is rendered (contacts page has MultiFamilyLeadsPageContext)
    contactsPageQueryParams!,
    {
      enabled: !!listingAlias,
      staleTime: Infinity,
      meta: {
        context: {
          api: 'getLatestConversationsForContactsPage',
          details: 'ViewInMessagesButton - Error fetching conversations',
        },
      },
    },
  );

  const hasConversations = data?.conversations && data.conversations.length > 0;

  if (isLoading || !listingAlias || !hasConversations) {
    return null;
  }

  return (
    <Link
      legacyBehavior
      href={{
        pathname: '/inbox/[[...conversationSlug]]',
        query: {
          conversationSlug: [listingAlias],
          byProperty: 'true',
        },
      }}
      passHref
    >
      <Button asChild tone="neutral" emphasis="outlined" icon={<IconMailOutline />} iconPosition="end" size="lg">
        <a>View in messages</a>
      </Button>
    </Link>
  );
}
